import { createContext } from 'react';
interface DrawerContextProps {
  isDrawerOpen: (id: string) => boolean;
  openDrawer: (id: string) => void;
  closeDrawer: (id: string) => void;
  closeAllDrawers: () => void;
}
export const DrawerContext = createContext<DrawerContextProps | undefined>(undefined);